import {useCallback, useMemo} from 'react';
import {useRouter} from 'next/router';

import {authReturnParams, buildAuthPath} from '@/utils/authReturnDestination';

/**
 * Builds sign-in / sign-up links that return the user to the page they are on (FUNC-303).
 *
 * `returnParams` is for the `queryParams` prop on AppBarLink / MenuLink, which appends them to the
 * rendered href without changing the tracked path. `authPath` is for callers that need a complete
 * href.
 */
const useAuthReturnDestination = () => {
  const {asPath} = useRouter();

  const returnParams = useMemo(() => authReturnParams(asPath), [asPath]);
  const authPath = useCallback((path: string) => buildAuthPath(path, asPath), [asPath]);

  return {authPath, returnParams};
};

export default useAuthReturnDestination;
